import { useTranslation } from 'react-i18next'
import { Checkbox, Spinner } from '@platform/ui'
import { FilterType, IFilter } from './types'

export type FilterOption<T extends string> = {
  label: string
  value: T
}

type Props<T extends string> = {
  filters: IFilter
  filterType: FilterType
  options: FilterOption<T>[]
  onChange: (filterType: FilterType, value: T) => void
  isLoading?: boolean
}

export const CourseFilterCheckboxGroup = <T extends string>({
  filterType,
  options,
  filters,
  onChange,
  isLoading,
}: Props<T>) => {
  const { t, i18n } = useTranslation()

  // Helper function to get the correct filter array
  const getFilterArray = (filterType: FilterType): string[] => {
    // Check if it's a category filter with format "category[categoryId]"
    if (typeof filterType === 'string' && filterType.startsWith('category[') && filterType.endsWith(']')) {
      // Extract category ID from "category[categoryId]"
      const categoryId = filterType.slice(9, -1) // Remove "category[" and "]"
      return filters.category[categoryId] || []
    }

    // For regular filter types, access directly
    return (filters[filterType as keyof IFilter] as string[]) || []
  }

  const filterArray = getFilterArray(filterType)

  return (
    <>
      {isLoading && <Spinner />}
      {!isLoading &&
        options.map((option) => (
          <Checkbox
            key={option.value}
            checked={filterArray.includes(option.value) || false}
            onChange={() => onChange(filterType, option.value)}
            testId={`course-filter-${option.value}`}
          >
            {i18n.exists(option.label) ? t(option.label) : option.label}
          </Checkbox>
        ))}
    </>
  )
}
